module.exports = new __parcel__URL__("loading_screen_prog_bar.6fd69a92.png").toString();